/* istanbul ignore file */
import { useRouter as useNextRouter } from 'next/router';

export const useRouter = () => {
  const router = useNextRouter();

  const navigate = (path: string) => {
    router.push(path);
  };

  const goBack = () => {
    router.back();
  };

  return {
    navigate,
    goBack,
    ...router,
  };
};
